export default "__VITE_ASSET__KFNDxrF0__"